import { faPencil, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useArtistContext } from "../ArtistPageContext";

export default function ArtistPageHighlights({ artist, onShowModal }) {
  const { isOwner } = useArtistContext();

  return (
    <div className="grid__column column column--default column--placeholder">
      <div className='column__heading heading'>
        <div>
          <div className="heading__title">
            Highlights
          </div>
          <div className="heading__subtitle">
            Stay tuned for my latest releases
          </div>
        </div>
        { isOwner && (
          <button className='button button--primary button--fill button--icon' onClick={ onShowModal }>
            <FontAwesomeIcon icon={ faPencil } />
          </button>
        ) }
      </div>
      <div className="column__embed-group">
        { artist.spotify_highlight && (
          <iframe
            className='spotify-player'
            data-testid="embed-iframe"
            style={ { borderRadius: '16px' } }
            src={ `https://open.spotify.com/embed/track/${artist.spotify_highlight}?theme=0` }
            width="100%"
            height="152"
            frameBorder="0"
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            allowFullScreen
            loading="lazy"
            title="Spotify Player"
          />
        ) }
        { !artist.spotify_highlight && isOwner && (
          <div>
            <button className='button button--primary button--outline' onClick={ onShowModal }>
              Add Spotify Link <FontAwesomeIcon icon={ faPlus } />
            </button>
          </div>
        ) }
        { !artist.spotify_highlight && !isOwner && (
          <div className="embed-group__placeholder embed-group__placeholder--spotify">
            <svg width="62" height="64" viewBox="0 0 62 64" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M31 1C48 1 62 15 62 32C62 49.125 48 63 31 63C13.875 63 0 49.125 0 32C0 15 13.875 1 31 1ZM43.5 46.625C44.5 46.625 45.375 45.875 45.375 44.75C45.375 43.625 45 43.125 44.25 42.625C35.25 37.375 24.875 37.125 14.625 39.375C13.625 39.625 12.875 40.25 12.875 41.5C12.875 42.5 13.625 43.5 14.875 43.5C15.25 43.5 15.875 43.25 16.375 43.125C25.375 41.375 34.375 41.5 42.25 46.25C42.625 46.5 43 46.625 43.5 46.625ZM46.875 38.5C48.25 38.5 49.25 37.375 49.375 36C49.375 35 48.875 34.125 47.875 33.625C41.75 29.875 33.875 27.875 25.75 27.875C20.625 27.875 17 28.625 13.5 29.625C12.25 30 11.625 30.875 11.625 32.125C11.625 33.5 12.75 34.625 14 34.625C14.625 34.625 14.875 34.375 15.5 34.25C25.875 31.5 37.5 33.375 45.375 38C45.75 38.125 46.25 38.5 46.875 38.5ZM50.75 29C52.25 29 53.625 27.75 53.625 26C53.625 24.5 53 23.75 52 23.25C45.125 19.125 35.5 17.25 26.375 17.25C21 17.25 16.125 17.875 11.75 19.125C10.625 19.5 9.5 20.375 9.5 22.125C9.5 23.75 10.75 25.125 12.375 25.125C13 25.125 13.625 24.875 14 24.75C24.375 21.875 40.25 23.125 49.125 28.5C49.75 28.75 50.125 29 50.75 29Z" fill="currentColor"/>
            </svg>
          </div>
        ) }
        { artist.youtube_highlight && (
          <iframe
            className='yotube-player'
            width="100%"
            style={ { borderRadius: '16px' } }
            height="315"
            src={ `https://www.youtube.com/embed/${artist.youtube_highlight}` }
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          />
        ) }
        { !artist.youtube_highlight && isOwner && (
          <div>
            <button className='button button--primary button--outline' onClick={ onShowModal }>
              Add YouTube Link <FontAwesomeIcon icon={ faPlus } />
            </button>
          </div>
        ) }
        { !artist.youtube_highlight && !isOwner && (
          <div className="embed-group__placeholder embed-group__placeholder--youtube">
            <svg width="72" height="64" viewBox="0 0 72 64" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M68.625 15.625C70.125 20.875 70.125 32.125 70.125 32.125C70.125 32.125 70.125 43.25 68.625 48.625C67.875 51.625 65.5 53.875 62.625 54.625C57.25 56 36 56 36 56C36 56 14.625 56 9.25 54.625C6.375 53.875 4 51.625 3.25 48.625C1.75 43.25 1.75 32.125 1.75 32.125C1.75 32.125 1.75 20.875 3.25 15.625C4 12.625 6.375 10.25 9.25 9.5C14.625 8 36 8 36 8C36 8 57.25 8 62.625 9.5C65.5 10.25 67.875 12.625 68.625 15.625ZM29 42.25L46.75 32.125L29 22V42.25Z" fill="currentColor"/>
            </svg>
          </div>
        ) }
      </div>
    </div>
  );
};
